import React, { Component } from 'react';
import moment from 'moment';
import Select from 'react-select';
import makeCancellablePromise from 'make-cancellable-promise';
import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { toast } from 'react-toastify';

import { db } from './../helper/firebase';

class App extends Component{
  constructor(){
    super();
    
    this.state = {
      url: '',

      date: '',
      dateOption: [],
      dateLoad: true,

      destination: '',
      destinationOption: [],
      destinationLoad: true,

      interest: '',
      interestOption: [],
      interestLoad: true
    }

    this.cancellableSetting = '';
    this.cancellableDestination = '';
    this.cancellableInterest = '';

    this.selectChange = this.selectChange.bind(this);
  }

  componentDidMount(){
    const newDate = new Date(),
          startMonth = newDate.getMonth() + 1,
          startYear = newDate.getFullYear();

    let writeMonth = startMonth,
        writeYear = startYear,
        listDate = [];

    for(let i = startMonth; i < ((12 * 2) + 1); i++){
      const writeValue = `${writeYear}-${writeMonth.toString().length === 2 ? writeMonth : `0${writeMonth}`}`,
            dateCollect = {
              value: writeValue,
              label: moment(new Date(writeValue)).format('MMMM YYYY')
            };

      listDate.push(dateCollect);

      writeMonth++;

      if(writeMonth === 13){
        writeMonth = 1;
        writeYear++;
      }
    }

    this.setState({
      dateOption: listDate,
      dateLoad: false
    });

    this.cancellableSetting = makeCancellablePromise(
      getDocs(
        query(
          collection(db, 'setting'), limit(1)
        )
      )
    );

    this.cancellableSetting.promise.then((settingSnapshot) => {
      if(settingSnapshot.size){
        this.setState({ url: settingSnapshot.docs[0].data().settingUrl });
      }
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));
    });

    this.cancellableDestination = makeCancellablePromise(
      getDocs(
        query(
          collection(db, 'destination'), where('destinationStatus', '==', true), where('destinationActive', '==', true), orderBy('destinationIndex')
        )
      )
    );

    this.cancellableDestination.promise.then((destinationSnapshot) => {
      if(destinationSnapshot.size){
        let listDestination = [];

        destinationSnapshot.forEach((destinationDoc) => {
          const destinationData = destinationDoc.data();
          
          listDestination.push({
            label: destinationData.destinationName,
            keyword: destinationData.destinationKeyword,
            value: destinationData.destinationSlug,
          });
        });

        this.setState({ destinationOption: listDestination });
      }
      
      this.setState({ destinationLoad: false });
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));

      this.setState({ destinationLoad: false });
    });

    this.cancellableInterest = makeCancellablePromise(
      getDocs(
        query(
          collection(db, 'interest'), where('interestStatus', '==', true), where('interestActive', '==', true), orderBy('interestIndex')
        )
      )
    );

    this.cancellableInterest.promise.then((interestSnapshot) => {
      if(interestSnapshot.size){
        let listInterest = [];

        interestSnapshot.forEach((interestDoc) => {
          const interestData = interestDoc.data();
          
          listInterest.push({
            // id: interestDoc.id,
            label: interestData.interestName,
            value: interestData.interestSlug,
          });
        });

        this.setState({ interestOption: listInterest });
      }
      
      this.setState({ interestLoad: false });
    }).catch((error) => {
      console.error(error);

      toast.error(() => (<>{error.code}<span>{error.message}</span></>));

      this.setState({ interestLoad: false });
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.date !== prevState.date){
      if(this.state.date && this.state.url){
        window.top.location.href = `${this.state.url}/?date=${this.state.date.value}`;
      }
      
    }

    if(this.state.destination !== prevState.destination){
      if(this.state.destination){
        window.top.location.href = `${this.state.url}/?destination=${this.state.destination.value}`;
      }
    }

    if(this.state.interest !== prevState.interest){
      if(this.state.interest){
        window.top.location.href = `${this.state.url}/?interest=${this.state.interest.value}`;
      }
    }
  }

  componentWillUnmount(){
    if(this.cancellableSetting){
      this.cancellableSetting.cancel();
    }

    if(this.cancellableDestination){
      this.cancellableDestination.cancel();
    }

    if(this.cancellableInterest){
      this.cancellableInterest.cancel();
    }
  }

  selectChange(value, event){
    this.setState({ [event.name]: value });
  }

  render(){
    // const formatImg = ({ label, img }) => (
    //         <div className="img-wrap">
    //           <div className="img">
    //             <img src={img} alt={label} />
    //           </div>{label}
    //         </div>
    //       );

    return (
      <div className="section">
        <section>
          {/* <h1>
            Start Your Ocean Journey
          </h1>
          <div className="sub-tit">
            Explore 150+ liveaboards journey across 17,000+ islands in the Indonesian archipelago with Liveaboard Indonesia
          </div> */}
          <ul className="form">
            <li>
              <div>
                <h2>When to go</h2>
                <Select
                  name="date"
                  value={this.state.date}
                  onChange={this.selectChange}
                  options={this.state.dateOption}
                  className="react-select"
                  classNamePrefix="react-select"
                  noOptionsMessage={() => 'No date choice.'}
                  menuPortalTarget={document.querySelector('body')}
                  isDisabled={this.state.dateLoad}
                  isLoading={this.state.dateLoad}
                  placeholder="Select date..."
                />
              </div>
            </li>
            <li>OR</li>
            <li>
              <div>
                <h2>Where to go</h2>
                <Select
                  name="destination"
                  value={this.state.destination}
                  onChange={this.selectChange}
                  options={this.state.destinationOption}
                  className="react-select"
                  classNamePrefix="react-select"
                  noOptionsMessage={() => 'No destination choice.'}
                  menuPortalTarget={document.querySelector('body')}
                  isDisabled={this.state.destinationLoad}
                  isLoading={this.state.destinationLoad}
                  placeholder="Select destination..."
                  filterOption={(options, filterString) => {
                    const labelLower = options.label.toLowerCase(),
                          keywordLower = options.data.keyword.toLowerCase(),
                          filterLower = filterString.toLowerCase();
                    
                    return labelLower.includes(filterLower) || keywordLower.includes(filterLower);
                  }}
                />
              </div>
            </li>
            <li>OR</li>
            <li>
              <div>
                <h2>What to do</h2>
                <Select
                  name="interest"
                  value={this.state.interest}
                  onChange={this.selectChange}
                  options={this.state.interestOption}
                  className="react-select"
                  classNamePrefix="react-select"
                  noOptionsMessage={() => 'No interest choice.'}
                  menuPortalTarget={document.querySelector('body')}
                  isDisabled={this.state.interestLoad}
                  isLoading={this.state.interestLoad}
                  placeholder="Select interest..."
                />
              </div>
            </li>
          </ul>
        </section>
      </div>
    );
  }
}

export default App;
